import { Component, OnInit, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { FormsModule } from '@angular/forms';
import Swal from 'sweetalert2';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { ApiService } from 'app/shared/api.service';
import { TranslocoModule } from '@ngneat/transloco';

interface PartnershipForm {
    event_name: string;
    event_date: string;
    location: string;
    qty_participant: string;
    proposal_file?: File | null;
}

export interface WeddingProductItem {
    id: number;
    code: string;
    tag: string;
    title: string;
    coupleName: string;
    weddingDate: string;
    location: string;
    badge: string;
    image: string;
    hoverImage?: string;
    hasPhoneFrame?: boolean;
    slug: string;
    themePath?: string;
    demoUrl?: string;
}

export interface PartnerItem {
    id: string;
    title: string;
    type: string;
    description: string;
    link_url?: string | null;
    cta_text?: string | null;
    sort_order: number;
    is_active: boolean;
    asset: {
        id: number;
        file_name: string;
        mime_type: string;
        type: string;
        url: string;
        size?: number;
    };
    displayName?: string;
    category?: string;
}

@Component({
    selector: 'app-home',
    standalone: true,
    imports: [CommonModule, FormsModule, TranslocoModule, RouterModule],
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {
    phone = '6282260084847';
    message = 'Halo, saya tertarik untuk memesan PhotoBooth. Bisa bantu saya dengan informasi lebih lanjut mengenai paket ini? Terima kasih!';

    isSubmitting = false;
    selectedFile: File | null = null;

    PartnershipForm: any[] = [];

    // Form Partnership
    partnershipForm: PartnershipForm = {
        event_name: '',
        event_date: '',
        location: '',
        qty_participant: '',
    };

    // Welcome Voucher Popup State (Shopee-like Mechanism: muncul sekali per reload web)
    private static voucherPopupShownInSession: boolean = false;
    isVoucherPopupOpen: boolean = false;
    promoBanner: any = null;
    voucherBannerUrl: string = '';

    // 3D Curved Smartphone Carousel State for Wedding Invitations
    activeSlideIndex: number = 2; // Default to theme43 / Garden Classic in the center
    autoPlayInterval: any = null;
    isHovered: boolean = false;
    touchStartX: number = 0;
    touchEndX: number = 0;
    screenWidth: number = 1200;

    // Manual Drag & Swipe State
    isDragging: boolean = false;
    dragStartX: number = 0;
    dragDeltaX: number = 0;
    hasDragged: boolean = false;

    // Modal Pilih Agama State
    isAgamaModalOpen: boolean = false;
    selectedAgama: string = 'islam';
    selectedProductForDemo: WeddingProductItem | null = null;
    isSubmittingAgama: boolean = false;
    // Scroll Reveal IntersectionObserver State
    private scrollObserver: IntersectionObserver | null = null;

    religions = [
        { id: 'islam', name: 'Islam', ceremony: 'Akad & Walimah' },
        { id: 'kristen protestan', name: 'Kristen Protestan', ceremony: 'Pemberkatan Nikah' },
        { id: 'kristen katolik', name: 'Kristen Katolik', ceremony: 'Sakramen Pernikahan' },
        { id: 'hindu', name: 'Hindu', ceremony: 'Upacara Pawiwahan' },
        { id: 'buddha', name: 'Buddha', ceremony: 'Pemberkatan Pernikahan' },
        { id: 'konghucu', name: 'Konghucu', ceremony: 'Upacara Li Yi' },
    ];

    weddingProducts: WeddingProductItem[] = [
        {
            id: 1,
            code: '#01',
            tag: 'Retro Arcade',
            title: 'Retro Game Romance',
            coupleName: 'Rama & Shinta',
            weddingDate: '24 . 10 . 2026',
            location: 'Plataran Cilandak, Jakarta',
            badge: 'POPULAR GAME',
            image: '/assets/visidea/theme-2.jpg',
            hasPhoneFrame: true,
            slug: 'wedding-of-retro-game-romance',
            demoUrl: 'https://invitation.visideastudio.com/wedding-of-retro-game-romance?to=Johan%20Susanto'
        },
        {
            id: 2,
            code: '#02',
            tag: 'Royal Luxury',
            title: 'Royal Midnight Chapel',
            coupleName: 'Dimas & Sarah',
            weddingDate: '18 . 09 . 2026',
            location: 'The Mulia Resort, Bali',
            badge: 'EXCLUSIVE',
            image: '/assets/visidea/theme-1.jpg',
            hasPhoneFrame: true,
            slug: 'wedding-of-royal-midnight-chapel',
            demoUrl: 'https://invitation.visideastudio.com/wedding-of-royal-midnight-chapel?to=Johan%20Susanto'
        },
        {
            id: 3,
            code: '#03',
            tag: 'Traditional Luxury',
            title: 'Royal Sumatra',
            coupleName: 'Rian & Putri',
            weddingDate: '15 . 11 . 2026',
            location: 'Balai Samudera, Jakarta',
            badge: 'TRADITIONAL',
            image: '/assets/visidea/theme-3.jpg',
            hasPhoneFrame: true,
            slug: 'wedding-of-royal-sumatra',
            demoUrl: 'https://invitation.visideastudio.com/wedding-of-royal-sumatra?to=Johan%20Susanto'
        },
        {
            id: 4,
            code: '#04',
            tag: 'Elegant Glamour',
            title: 'Golden Veil',
            coupleName: 'Adrian & Jessica',
            weddingDate: '08 . 08 . 2026',
            location: 'The Dharmawangsa, Jakarta',
            badge: 'BEST SELLER',
            image: '/assets/visidea/theme-4.jpg',
            hasPhoneFrame: true,
            slug: 'wedding-of-golden-veil',
            demoUrl: 'https://invitation.visideastudio.com/wedding-of-golden-veil?to=Johan%20Susanto'
        },
        {
            id: 5,
            code: '#05',
            tag: 'Botanical Garden',
            title: 'Garden Classic',
            coupleName: 'Mustika & Wira',
            weddingDate: '20 . 06 . 2026',
            location: 'Pine Hill, Bandung',
            badge: 'SIGNATURE',
            image: '/assets/visidea/themes/cover-theme43.png',
            hasPhoneFrame: true,
            slug: 'wedding-of-garden-classic',
            themePath: 'template6/theme43',
            demoUrl: 'https://invitation.visideastudio.com/wedding-of-garden-classic?to=Johan%20Susanto'
        }
    ];

    // =========================================================
    // OUR PARTNERS SHOWCASE STATE & DATA
    // =========================================================
    isLoadingPartners: boolean = false;
    partnerActiveTab: 'marquee' | 'spotlight' = 'marquee';
    currentPartnerSlideIndex: number = 0;
    isPartnerSlideDragging: boolean = false;
    partnerTouchSlideStartX: number = 0;
    selectedPartnerCategory: string = 'all';
    isPartnerDetailModalOpen: boolean = false;
    activePartnerDetail: PartnerItem | null = null;

    partnersList: PartnerItem[] = [
        {
            id: '01a113f9-fb02-7069-9bcf-f7e138cc5ff7',
            title: 'partnership',
            type: 'partnership_img',
            description: 'ITB Career Center',
            link_url: null,
            cta_text: 'image',
            sort_order: 0,
            is_active: true,
            asset: {
                id: 324,
                file_name: 'logo_itbcareercenter.png',
                mime_type: 'image/png',
                type: 'image',
                url: 'https://dev.api.visideastudio.com/storage/324/logo_itbcareercenter.png',
                size: 13502
            },
            displayName: 'ITB Career Center',
            category: 'Education & Career'
        },
        {
            id: '01a113fb-5d1d-7111-8963-c2f29d80323f',
            title: 'partnership',
            type: 'partnership_img',
            description: 'Orchid Forest Cikole',
            link_url: null,
            cta_text: 'image',
            sort_order: 1,
            is_active: true,
            asset: {
                id: 325,
                file_name: 'logo_orchidforestcikole.png',
                mime_type: 'image/png',
                type: 'image',
                url: 'https://dev.api.visideastudio.com/storage/325/logo_orchidforestcikole.png',
                size: 201443
            },
            displayName: 'Orchid Forest Cikole',
            category: 'Tourism & Venue'
        },
        {
            id: '01a113fb-7d62-7128-baa1-d0998a28ecfc',
            title: 'partnership',
            type: 'partnership_img',
            description: 'Perum BULOG',
            link_url: null,
            cta_text: 'image',
            sort_order: 2,
            is_active: true,
            asset: {
                id: 326,
                file_name: 'logo_bulog.jfif',
                mime_type: 'image/jpeg',
                type: 'image',
                url: 'https://dev.api.visideastudio.com/storage/326/logo_bulog.jfif',
                size: 25932
            },
            displayName: 'Perum BULOG',
            category: 'BUMN & Enterprise'
        },
        {
            id: '01a113fb-9e51-73df-af3b-bee9832b21f9',
            title: 'partnership',
            type: 'partnership_img',
            description: 'English 1',
            link_url: null,
            cta_text: 'image',
            sort_order: 3,
            is_active: true,
            asset: {
                id: 327,
                file_name: 'logo_english1.png',
                mime_type: 'image/png',
                type: 'image',
                url: 'https://dev.api.visideastudio.com/storage/327/logo_english1.png',
                size: 19692
            },
            displayName: 'English 1',
            category: 'Education & Course'
        },
        {
            id: '01a113fb-c23b-70f8-b32d-fd15a3a15874',
            title: 'partnership',
            type: 'partnership_img',
            description: 'Dusun Bambu',
            link_url: null,
            cta_text: 'image',
            sort_order: 4,
            is_active: true,
            asset: {
                id: 328,
                file_name: 'logo_dusunbambu.jfif',
                mime_type: 'image/jpeg',
                type: 'image',
                url: 'https://dev.api.visideastudio.com/storage/328/logo_dusunbambu.jfif',
                size: 11893
            },
            displayName: 'Dusun Bambu Resort',
            category: 'Destination & Resort'
        },
        {
            id: '01a113fb-e369-73e9-af96-675978401ee6',
            title: 'partnership',
            type: 'partnership_img',
            description: 'Beauty Your Fest',
            link_url: null,
            cta_text: 'image',
            sort_order: 5,
            is_active: true,
            asset: {
                id: 329,
                file_name: 'logo_beautyyourfest.jfif',
                mime_type: 'image/jpeg',
                type: 'image',
                url: 'https://dev.api.visideastudio.com/storage/329/logo_beautyyourfest.jfif',
                size: 25128
            },
            displayName: 'Beauty Your Fest',
            category: 'Festival & Lifestyle'
        },
        {
            id: '01a11400-9a3d-7107-b269-e4398446f18e',
            title: 'partnership',
            type: 'partnership_img',
            description: 'BAZNAS',
            link_url: null,
            cta_text: 'image',
            sort_order: 6,
            is_active: true,
            asset: {
                id: 330,
                file_name: 'logo_baznas.png',
                mime_type: 'image/png',
                type: 'image',
                url: 'https://dev.api.visideastudio.com/storage/330/logo_baznas.png',
                size: 44285
            },
            displayName: 'BAZNAS RI',
            category: 'National Institution'
        },
        {
            id: '01a11400-d066-704b-926d-ffdf875043e3',
            title: 'partnership',
            type: 'partnership_img',
            description: 'TRANS7',
            link_url: null,
            cta_text: 'image',
            sort_order: 7,
            is_active: true,
            asset: {
                id: 331,
                file_name: 'Logo_Trans7.png',
                mime_type: 'image/png',
                type: 'image',
                url: 'https://dev.api.visideastudio.com/storage/331/Logo_Trans7.png',
                size: 50154
            },
            displayName: 'TRANS7',
            category: 'Media & Television'
        },
        {
            id: '01a11401-03e7-730f-a3b0-3b2b13eabd22',
            title: 'partnership',
            type: 'partnership_img',
            description: 'Abang None Jakarta',
            link_url: null,
            cta_text: 'image',
            sort_order: 8,
            is_active: true,
            asset: {
                id: 332,
                file_name: 'abangnonejakarta.jfif',
                mime_type: 'image/jpeg',
                type: 'image',
                url: 'https://dev.api.visideastudio.com/storage/332/abangnonejakarta.jfif',
                size: 7661
            },
            displayName: 'Abang None Jakarta',
            category: 'Culture & Government'
        },
        {
            id: '01a11401-3eaf-724e-b37a-831fc30970d7',
            title: 'partnership',
            type: 'partnership_img',
            description: 'Perum Jasa Tirta II',
            link_url: null,
            cta_text: 'image',
            sort_order: 9,
            is_active: true,
            asset: {
                id: 333,
                file_name: 'logo_perumjasa2.webp',
                mime_type: 'image/webp',
                type: 'image',
                url: 'https://dev.api.visideastudio.com/storage/333/logo_perumjasa2.webp',
                size: 95346
            },
            displayName: 'Perum Jasa Tirta II',
            category: 'BUMN & Enterprise'
        }
    ];

    constructor(
        private ApiService: ApiService,
        private router: Router
    ) { }

    @HostListener('window:resize')
    onResize() {
        this.updateScreenDimensions();
    }

    private updateScreenDimensions() {
        if (typeof window !== 'undefined') {
            this.screenWidth = window.innerWidth;
        }
    }

    ngOnInit(): void {
        this.updateScreenDimensions();
        this.fetchWeddingThemes();
        this.fetchPartners();
        this.fetchPromoBanner();
        this.startAutoPlay();

        // Shopee-style popup: Muncul hanya 1x per load/reload web
        if (!HomeComponent.voucherPopupShownInSession) {
            HomeComponent.voucherPopupShownInSession = true;
            setTimeout(() => {
                this.isVoucherPopupOpen = true;
            }, 400);
        }
    }

    ngAfterViewInit(): void {
        this.initScrollReveal();
    }

    // =========================================================
    // SCROLL REVEAL ENTRANCE ANIMATION (GPU-ACCELERATED)
    // =========================================================
    private initScrollReveal(): void {
        if (typeof window === 'undefined') return;

        // Fallback jika browser tidak mendukung IntersectionObserver
        if (!('IntersectionObserver' in window)) {
            const elements = document.querySelectorAll('.scroll-reveal');
            elements.forEach(el => el.classList.add('revealed'));
            return;
        }

        this.scrollObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('revealed');
                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.08,
            rootMargin: '0px 0px -30px 0px'
        });

        // Observe semua elemen yang memiliki class .scroll-reveal
        const elements = document.querySelectorAll('.scroll-reveal');
        elements.forEach(el => this.scrollObserver?.observe(el));
    }

    private refreshScrollReveal(): void {
        if (!this.scrollObserver || typeof window === 'undefined') return;
        const unrevealed = document.querySelectorAll('.scroll-reveal:not(.revealed)');
        unrevealed.forEach(el => this.scrollObserver?.observe(el));
    }

    // =========================================================
    // PARTNER API & LOGIC METHODS
    // =========================================================
    async fetchPartners(): Promise<void> {
        this.isLoadingPartners = true;
        try {
            const apiEndpoint = '/api/v1/front/public/showcases/list?type=partnership_img';
            let response: any = await this.ApiService.get(apiEndpoint, false);

            if (!response || !response.success || !response.data?.list) {
                try {
                    const devRes = await fetch(`https://dev.api.visideastudio.com${apiEndpoint}`);
                    if (devRes.ok) {
                        response = await devRes.json();
                    }
                } catch (e) {
                    console.error('Dev fallback error for partner showcases:', e);
                }
            }

            let rawList: any[] = [];
            if (response && response.data) {
                if (Array.isArray(response.data.list)) {
                    rawList = response.data.list;
                } else if (Array.isArray(response.data)) {
                    rawList = response.data;
                } else if (Array.isArray(response.data.data)) {
                    rawList = response.data.data;
                }
            } else if (Array.isArray(response?.list)) {
                rawList = response.list;
            }

            if (rawList && rawList.length > 0) {
                const activeList = rawList
                    .filter((item: any) => item.is_active !== false && item.asset?.url)
                    .sort((a: any, b: any) => {
                        const orderA = a.sort_order !== undefined && a.sort_order !== null && a.sort_order !== '' ? Number(a.sort_order) : 9999;
                        const orderB = b.sort_order !== undefined && b.sort_order !== null && b.sort_order !== '' ? Number(b.sort_order) : 9999;
                        if (orderA !== orderB) return orderA - orderB;
                        return new Date(b.created_at || 0).getTime() - new Date(a.created_at || 0).getTime();
                    })
                    .map((item: any) => ({
                        ...item,
                        displayName: this.formatPartnerName(item),
                        category: this.getPartnerCategory(item)
                    }));

                if (activeList.length > 0) {
                    this.partnersList = activeList;
                }
            }
        } catch (error) {
            console.error('Error fetching partner showcases:', error);
        } finally {
            this.isLoadingPartners = false;
        }
    }

    formatPartnerName(item: any): string {
        if (item.description && item.description.trim() !== '' && item.description.toLowerCase() !== 'partnership' && item.description.toLowerCase() !== 'image') {
            return item.description;
        }
        if (item.title && item.title.trim() !== '' && item.title.toLowerCase() !== 'partnership') {
            return item.title;
        }
        const fileName = item.asset?.file_name || '';
        let name = fileName.replace(/\.[^/.]+$/, '');
        name = name.replace(/^logo[_-]?/i, '');

        const specialMap: Record<string, string> = {
            'itbcareercenter': 'ITB Career Center',
            'orchidforestcikole': 'Orchid Forest Cikole',
            'bulog': 'Perum BULOG',
            'english1': 'English 1',
            'dusunbambu': 'Dusun Bambu Resort',
            'beautyyourfest': 'Beauty Your Fest',
            'baznas': 'BAZNAS RI',
            'trans7': 'TRANS7',
            'abangnonejakarta': 'Abang None Jakarta',
            'perumjasa2': 'Perum Jasa Tirta II'
        };
        const key = name.toLowerCase().replace(/[^a-z0-9]/g, '');
        if (specialMap[key]) {
            return specialMap[key];
        }
        return name.replace(/[_-]/g, ' ').replace(/\b\w/g, (c: string) => c.toUpperCase());
    }

    getPartnerCategory(item: any): string {
        const str = ((item.asset?.file_name || '') + ' ' + (item.description || '') + ' ' + (item.title || '')).toLowerCase();
        if (str.includes('itb') || str.includes('career') || str.includes('english')) return 'Education & Academy';
        if (str.includes('orchid') || str.includes('dusun') || str.includes('bambu') || str.includes('resort')) return 'Destination & Venue';
        if (str.includes('bulog') || str.includes('jasa') || str.includes('tirta')) return 'BUMN & Enterprise';
        if (str.includes('beauty') || str.includes('fest')) return 'Festival & Lifestyle';
        if (str.includes('baznas')) return 'National Institution';
        if (str.includes('trans7') || str.includes('trans')) return 'Media & Broadcast';
        if (str.includes('abang') || str.includes('none') || str.includes('jakarta')) return 'Culture & Government';
        return 'Official Partner';
    }

    get partnersRow1(): PartnerItem[] {
        const half = Math.ceil(this.partnersList.length / 2);
        const items = this.partnersList.slice(0, half);
        return [...items, ...items, ...items, ...items];
    }

    get partnersRow2(): PartnerItem[] {
        const half = Math.ceil(this.partnersList.length / 2);
        const items = this.partnersList.slice(half);
        return [...items, ...items, ...items, ...items];
    }

    get filteredPartners(): PartnerItem[] {
        if (this.selectedPartnerCategory === 'all') return this.partnersList;
        return this.partnersList.filter(p => {
            const cat = (p.category || '').toLowerCase();
            return cat.includes(this.selectedPartnerCategory.toLowerCase());
        });
    }

    get partnerCardsPerView(): number {
        if (typeof window === 'undefined') return 4;
        if (this.screenWidth < 640) return 1;
        if (this.screenWidth < 1024) return 2;
        if (this.screenWidth < 1280) return 3;
        return 4;
    }

    get maxPartnerSlideIndex(): number {
        return Math.max(0, this.filteredPartners.length - this.partnerCardsPerView);
    }

    get partnerProgressPercentage(): number {
        if (this.maxPartnerSlideIndex === 0) return 100;
        return Math.min(100, Math.max(20, ((this.currentPartnerSlideIndex + 1) / (this.maxPartnerSlideIndex + 1)) * 100));
    }

    nextPartnerSlide(): void {
        if (this.currentPartnerSlideIndex < this.maxPartnerSlideIndex) {
            this.currentPartnerSlideIndex++;
        } else {
            this.currentPartnerSlideIndex = 0;
        }
    }

    prevPartnerSlide(): void {
        if (this.currentPartnerSlideIndex > 0) {
            this.currentPartnerSlideIndex--;
        } else {
            this.currentPartnerSlideIndex = this.maxPartnerSlideIndex;
        }
    }

    setPartnerSlide(index: number): void {
        this.currentPartnerSlideIndex = Math.min(index, this.maxPartnerSlideIndex);
    }

    onPartnerTouchStart(e: TouchEvent): void {
        if (e.touches && e.touches.length > 0) {
            this.partnerTouchSlideStartX = e.touches[0].clientX;
            this.isPartnerSlideDragging = true;
        }
    }

    onPartnerTouchMove(e: TouchEvent): void {
        if (!this.isPartnerSlideDragging || !e.touches || e.touches.length === 0) return;
        const currentX = e.touches[0].clientX;
        const deltaX = currentX - this.partnerTouchSlideStartX;
        const threshold = 40;
        if (deltaX < -threshold) {
            this.nextPartnerSlide();
            this.partnerTouchSlideStartX = currentX;
            this.isPartnerSlideDragging = false;
        } else if (deltaX > threshold) {
            this.prevPartnerSlide();
            this.partnerTouchSlideStartX = currentX;
            this.isPartnerSlideDragging = false;
        }
    }

    onPartnerTouchEnd(): void {
        this.isPartnerSlideDragging = false;
    }

    openPartnerModal(partner: PartnerItem): void {
        this.activePartnerDetail = partner;
        this.isPartnerDetailModalOpen = true;
    }

    closePartnerModal(): void {
        this.isPartnerDetailModalOpen = false;
        this.activePartnerDetail = null;
    }

    openPartnershipWhatsApp(): void {
        const text = encodeURIComponent('Halo Visidea Studio, saya tertarik untuk mendiskusikan peluang kemitraan / kolaborasi event bersama Visidea. Boleh minta informasi lebih lanjut? Terima kasih!');
        window.open(`https://wa.me/${this.phone}?text=${text}`, '_blank');
    }

    closeVoucherPopup(event?: Event): void {
        if (event) {
            event.stopPropagation();
        }
        this.isVoucherPopupOpen = false;
    }

    goToVoucherPage(): void {
        this.isVoucherPopupOpen = false;
        if (this.promoBanner?.link_url) {
            if (this.promoBanner.link_url.startsWith('http')) {
                window.open(this.promoBanner.link_url, '_blank');
            } else {
                this.router.navigate([this.promoBanner.link_url]);
            }
        } else {
            this.router.navigate(['/voucher']);
        }
    }

    async fetchPromoBanner(): Promise<void> {
        try {
            const apiEndpoint = '/api/v1/front/public/showcases/list?type=promo_banner';
            let response: any = await this.ApiService.get(apiEndpoint, false);

            if (!response || !response.success || !response.data?.list) {
                try {
                    const devRes = await fetch(`https://dev.api.visideastudio.com${apiEndpoint}`);
                    if (devRes.ok) {
                        response = await devRes.json();
                    }
                } catch (e) {
                    console.error('Dev fallback error for promo banner:', e);
                }
            }

            let rawList: any[] = [];
            if (response && response.data) {
                if (Array.isArray(response.data.list)) {
                    rawList = response.data.list;
                } else if (Array.isArray(response.data)) {
                    rawList = response.data;
                } else if (Array.isArray(response.data.data)) {
                    rawList = response.data.data;
                }
            } else if (Array.isArray(response?.list)) {
                rawList = response.list;
            }

            if (rawList && rawList.length > 0) {
                const activeBanners = rawList
                    .filter((item: any) => item.is_active !== false && item.asset?.url)
                    .sort((a: any, b: any) => {
                        const orderA = a.sort_order !== undefined && a.sort_order !== null && a.sort_order !== '' ? Number(a.sort_order) : 9999;
                        const orderB = b.sort_order !== undefined && b.sort_order !== null && b.sort_order !== '' ? Number(b.sort_order) : 9999;
                        if (orderA !== orderB) return orderA - orderB;
                        return new Date(b.created_at || 0).getTime() - new Date(a.created_at || 0).getTime();
                    });

                if (activeBanners.length > 0) {
                    this.promoBanner = activeBanners[0];
                    this.voucherBannerUrl = activeBanners[0].asset.url;
                }
            }
        } catch (error) {
            console.error('Error fetching promo banner showcases:', error);
        }
    }

    async fetchWeddingThemes(): Promise<void> {
        try {
            const apiEndpoint = '/api/v1/front/public/themed-products/list?paginate=false&page=&per_page=';
            let response = await this.ApiService.get(apiEndpoint, false);

            if (!response || !response.success || !response.data?.list) {
                try {
                    const devRes = await fetch(`https://dev.api.visideastudio.com${apiEndpoint}`);
                    if (devRes.ok) {
                        response = await devRes.json();
                    }
                } catch (e) { }
            }

            let rawList: any[] = [];
            if (response && response.data) {
                if (Array.isArray(response.data.list)) {
                    rawList = response.data.list;
                } else if (Array.isArray(response.data)) {
                    rawList = response.data;
                } else if (Array.isArray(response.data.data)) {
                    rawList = response.data.data;
                }
            } else if (Array.isArray(response)) {
                rawList = response;
            }

            if (rawList && rawList.length > 0) {
                // Update images or demo URLs from API if found, without modifying the 5 fixed themes
                this.weddingProducts = this.weddingProducts.map((p) => {
                    const cleanTitle = p.title.toLowerCase().replace(/[^a-z0-9]/g, '');
                    const matched = rawList.find((item: any) => {
                        const s = String(item.slug || item.alias || '').toLowerCase().replace(/[^a-z0-9]/g, '');
                        const name = String(item.name || item.title || '').toLowerCase().replace(/[^a-z0-9]/g, '');
                        return (cleanTitle && (s.includes(cleanTitle) || name.includes(cleanTitle) || cleanTitle.includes(name)));
                    });
                    if (matched) {
                        const apiDemo = matched.demo_url || matched.url || matched.preview_url || matched.link;
                        return {
                            ...p,
                            demoUrl: apiDemo ? apiDemo : p.demoUrl,
                            image: matched.cover_image_url || matched.background_image_url || matched.image || p.image
                        };
                    }
                    return p;
                });
            }
        } catch (error) {
            console.warn('Error fetching wedding themes for carousel, using curated fallback:', error);
        }
    }

    ngOnDestroy(): void {
        this.stopAutoPlay();
        if (this.scrollObserver) {
            this.scrollObserver.disconnect();
            this.scrollObserver = null;
        }
    }

    startAutoPlay() {
        this.stopAutoPlay();
        this.autoPlayInterval = setInterval(() => {
            if (!this.isDragging && !this.isAgamaModalOpen) {
                this.nextSlide();
            }
        }, 2600);
    }

    stopAutoPlay() {
        if (this.autoPlayInterval) {
            clearInterval(this.autoPlayInterval);
            this.autoPlayInterval = null;
        }
    }

    resetAutoPlay() {
        this.startAutoPlay();
    }

    getDiff(index: number): number {
        const total = this.weddingProducts.length;
        let diff = (index - this.activeSlideIndex) % total;
        if (diff > total / 2) diff -= total;
        if (diff < -total / 2) diff += total;
        return diff;
    }

    getCardStyle(index: number): { [key: string]: any } {
        const diff = this.getDiff(index);
        const absDiff = Math.abs(diff);

        const isMobile = this.screenWidth < 640;
        const isTablet = this.screenWidth >= 640 && this.screenWidth < 1024;

        // Step spacing between cards along the X axis (compact for slightly smaller cards)
        const stepX = isMobile ? 80 : (isTablet ? 120 : 155);
        const xOffset = diff * stepX;

        // Convex curve: center card is prominent, side cards scale down gracefully
        const scale = isMobile
            ? (diff === 0 ? 1 : Math.max(0.72, 1 - absDiff * 0.14))
            : (diff === 0 ? 1.02 : Math.max(0.76, 1 - absDiff * 0.12));

        // 3D rotation: cards angle inward toward center (convex arc facing viewer)
        const rotateY = -diff * (isMobile ? 12 : 14);

        // Z translation: center card pushed forward, side cards recessed into screen
        const zTranslate = diff === 0 ? 25 : -absDiff * 25;

        // Z-Index: center is on top
        const zIndex = 30 - absDiff * 10;

        // Opacity based on distance from center
        let opacity = 1;
        if (absDiff === 1) opacity = 0.94;
        else if (absDiff === 2) opacity = isMobile ? 0.35 : 0.72;
        else if (absDiff > 2) opacity = 0;

        return {
            'transform': `translateX(${xOffset}px) scale(${scale}) rotateY(${rotateY}deg) translateZ(${zTranslate}px)`,
            'z-index': zIndex,
            'opacity': opacity,
            'pointer-events': absDiff > 2 ? 'none' : 'auto',
            'visibility': absDiff > 2 ? 'hidden' : 'visible'
        };
    }

    prevSlide() {
        const total = this.weddingProducts.length;
        this.activeSlideIndex = (this.activeSlideIndex - 1 + total) % total;
    }

    nextSlide() {
        const total = this.weddingProducts.length;
        this.activeSlideIndex = (this.activeSlideIndex + 1) % total;
    }

    goToSlide(index: number) {
        this.activeSlideIndex = index;
    }

    onCardClick(index: number) {
        if (this.hasDragged) return;
        const diff = this.getDiff(index);
        if (diff === 0) {
            this.openDemoModal(this.weddingProducts[index]);
        } else {
            this.goToSlide(index);
            this.resetAutoPlay();
        }
    }

    openDemoModal(item: WeddingProductItem) {
        this.selectedProductForDemo = item;
        this.isAgamaModalOpen = true;
        this.stopAutoPlay();
    }

    closeAgamaModal() {
        this.isAgamaModalOpen = false;
        this.resetAutoPlay();
    }

    selectAgama(id: string) {
        this.selectedAgama = id;
    }

    cleanAndFormatDemoUrl(raw: any, religionKey?: string): string {
        if (!raw || typeof raw !== 'string') return '';
        let url = raw.trim();

        const httpsLastIdx = url.lastIndexOf('https://');
        const httpLastIdx = url.lastIndexOf('http://');
        const lastIdx = Math.max(httpsLastIdx, httpLastIdx);
        if (lastIdx > 0) {
            url = url.substring(lastIdx);
        }

        const activeRel = (religionKey || this.selectedAgama || 'islam').toLowerCase();

        if (url.startsWith('http://') || url.startsWith('https://')) {
            if (activeRel) {
                if (url.includes('religion=')) {
                    url = url.replace(/([?&])religion=[^&]*/, `$1religion=${activeRel}`);
                } else {
                    const sep = url.includes('?') ? '&' : '?';
                    url = `${url}${sep}religion=${activeRel}`;
                }
            }
            return url;
        }

        url = url.replace(/^\/+/, '');
        return `https://invitation.visideastudio.com/${url}?to=Johan%20Susanto&religion=${activeRel}`;
    }

    async confirmAgamaAndOpenDemo() {
        if (!this.selectedAgama) return;

        this.isSubmittingAgama = true;
        const targetAgama = this.selectedAgama;

        try {
            const formData = new FormData();
            formData.append('agama', targetAgama);
            fetch(`https://invitation.visideastudio.com/save-agama/${encodeURIComponent(targetAgama)}`, {
                method: 'POST',
                mode: 'no-cors',
                body: formData
            }).catch(() => { });
        } catch (e) {
            // Ignore cross-origin error
        }

        // Determine destination demo URL
        let rawTargetUrl = 'https://invitation.visideastudio.com/wedding-of-garden-classic?to=Johan%20Susanto';
        if (this.selectedProductForDemo?.slug === 'garden-classic' || this.selectedProductForDemo?.themePath === 'template6/theme43') {
            rawTargetUrl = 'https://invitation.visideastudio.com/wedding-of-garden-classic?to=Johan%20Susanto';
        } else if (this.selectedProductForDemo?.demoUrl) {
            rawTargetUrl = this.selectedProductForDemo.demoUrl;
        }

        const targetUrl = this.cleanAndFormatDemoUrl(rawTargetUrl, targetAgama);

        this.closeAgamaModal();
        this.isSubmittingAgama = false;

        if (targetUrl && typeof window !== 'undefined') {
            // Open in popup window sized like smartphone (400x850)
            const width = 400;
            const height = 850;
            const left = (screen.width - width) / 2;
            const top = Math.max(50, (screen.height - height) / 2);

            const features = [
                `width=${width}`,
                `height=${height}`,
                `left=${left}`,
                `top=${top}`,
                'resizable=yes',
                'scrollbars=yes',
                'toolbar=no',
                'menubar=no',
                'location=no',
                'directories=no',
                'status=no',
                'copyhistory=no',
                'popup=yes'
            ].join(',');

            const windowName = 'DemoUndangan_' + Date.now();
            const popup = window.open(targetUrl, windowName, features);

            if (popup) {
                popup.focus();
            } else {
                window.open(targetUrl, '_blank');
            }
        }
    }

    navigateToInvitation(item?: WeddingProductItem | string) {
        if (item && typeof item === 'object') {
            this.openDemoModal(item);
            return;
        }
        if (typeof item === 'string') {
            const found = this.weddingProducts.find(p => p.slug === item);
            if (found) {
                this.openDemoModal(found);
                return;
            }
        }
        this.router.navigate(['/digital-invitation', 'wedding-invitation']);
    }

    goToPhotobooth(slugOrType: string): void {
        const slug = (slugOrType || '').toLowerCase();
        if (slug.includes('360') || slug.includes('rolly') || slug.includes('videobooth')) {
            this.router.navigate(['/videobooth']);
        } else if (slug.includes('vintage')) {
            this.router.navigate(['/photobooth', 'vintage-photobooth']);
        } else if (slug.includes('poppy')) {
            this.router.navigate(['/photobooth', 'poppy-photobooth']);
        } else if (slug.includes('hyppe') || slug.includes('hype')) {
            this.router.navigate(['/photobooth', 'hyppe-photobooth']);
        } else {
            this.router.navigate(['/photobooth', slug]);
        }
    }

    goToGuestBook(type: string = 'lite') {
        this.router.navigate(['/guest-book', type]);
    }

    orderGuestBook(packageName: string = 'Digital Guest Book') {
        const type = packageName.toLowerCase().includes('premium') ? 'premium' : 'lite';
        this.goToGuestBook(type);
    }

    onMouseDown(e: MouseEvent) {
        this.isDragging = true;
        this.dragStartX = e.clientX;
        this.dragDeltaX = 0;
        this.hasDragged = false;
    }

    onMouseMove(e: MouseEvent) {
        if (!this.isDragging) return;
        this.dragDeltaX = e.clientX - this.dragStartX;
        if (Math.abs(this.dragDeltaX) > 8) {
            this.hasDragged = true;
        }
        const threshold = 45;
        if (this.dragDeltaX < -threshold) {
            this.nextSlide();
            this.dragStartX = e.clientX;
            this.dragDeltaX = 0;
            this.resetAutoPlay();
        } else if (this.dragDeltaX > threshold) {
            this.prevSlide();
            this.dragStartX = e.clientX;
            this.dragDeltaX = 0;
            this.resetAutoPlay();
        }
    }

    onMouseUp() {
        if (this.isDragging) {
            this.isDragging = false;
            setTimeout(() => {
                this.hasDragged = false;
            }, 60);
            this.resetAutoPlay();
        }
    }

    onMouseLeave() {
        if (this.isDragging) {
            this.isDragging = false;
            this.hasDragged = false;
        }
        this.isHovered = false;
    }

    onTouchStart(e: TouchEvent) {
        if (e.touches && e.touches.length > 0) {
            this.touchStartX = e.touches[0].clientX;
            this.isDragging = true;
            this.hasDragged = false;
        }
    }

    onTouchMove(e: TouchEvent) {
        if (!this.isDragging || !e.touches || e.touches.length === 0) return;
        const currentX = e.touches[0].clientX;
        const deltaX = currentX - this.touchStartX;
        if (Math.abs(deltaX) > 8) {
            this.hasDragged = true;
        }
        const threshold = 40;
        if (deltaX < -threshold) {
            this.nextSlide();
            this.touchStartX = currentX;
            this.resetAutoPlay();
        } else if (deltaX > threshold) {
            this.prevSlide();
            this.touchStartX = currentX;
            this.resetAutoPlay();
        }
    }

    onTouchEnd() {
        this.isDragging = false;
        setTimeout(() => {
            this.hasDragged = false;
        }, 60);
        this.resetAutoPlay();
    }


    async submitPartnership() {
        this.isSubmitting = true;

        try {
            const formData = new FormData();
            formData.append('event_name', this.partnershipForm.event_name);
            formData.append('event_date', this.partnershipForm.event_date);
            formData.append('location', this.partnershipForm.location);
            formData.append('qty_participant', this.partnershipForm.qty_participant);
            if (this.selectedFile) {
                formData.append('proposal_file', this.selectedFile, this.selectedFile.name);
            }

            await this.ApiService.post('/api/v1/tenant/public/partnership', formData);
            Swal.fire({
                icon: 'success',
                title: 'Submission Successful',
                text: 'Your partnership form has been submitted successfully.',
                confirmButtonColor: '#28a745',
                timer: 2000,
                showConfirmButton: false,
            });

            // Reset form
            this.partnershipForm = { event_name: '', event_date: '', location: '', qty_participant: '' };
            this.selectedFile = null;
        } catch (error) {
            console.error('Error submitting partnership form:', error);
            Swal.fire({
                icon: 'error',
                title: 'Submission Failed',
                text: 'An error occurred while submitting the partnership form. Please try again later.',
            });
        } finally {
            this.isSubmitting = false;
        }
    }

    async onSubmit(): Promise<void> {
        await this.submitPartnership();
    }

    // =========================================================
    // CUSTOMER REVIEWS SLIDER & ALL REVIEWS MODAL
    // =========================================================
    customerReviews: Array<{
        id: number;
        name: string;
        avatar: string;
        date: string;
        rating: number;
        comment: string;
        service: string;
    }> = [
        {
            id: 1,
            name: 'Ryan Almeida',
            avatar: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=150&auto=format&fit=crop&q=80',
            date: '1 day ago',
            rating: 5,
            comment: 'Pelayanan Visidea Studio luar biasa memuaskan! Hasil cetak photobooth super jernih dan tamu-tamu kami di pernikahan sangat senang dengan template kustomnya.',
            service: 'Photobooth'
        },
        {
            id: 2,
            name: 'Blossom Menezes',
            avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=150&auto=format&fit=crop&q=80',
            date: '3 days ago',
            rating: 5,
            comment: 'Undangan digitalnya sangat elegan dan responsif dibuka di smartphone. Musik backsound dan navigasi Google Maps-nya sangat membantu tamu kami.',
            service: 'Digital Invitation'
        },
        {
            id: 3,
            name: 'Jason Santoso',
            avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&auto=format&fit=crop&q=80',
            date: '1 week ago',
            rating: 5,
            comment: 'Buku tamu digital dengan scan QR code membuat registrasi tamu pernikahan kami tertata sangat rapi dan tanpa antrean panjang. Sangat recommended!',
            service: 'Guest Book'
        },
        {
            id: 4,
            name: 'Nadia & Dimas',
            avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&auto=format&fit=crop&q=80',
            date: '1 week ago',
            rating: 5,
            comment: '360 Videobooth dari Visidea bener-bener jadi primadona acara resepsi kami! Tim crew-nya sangat ramah, profesional, dan video langsung bisa diunduh tamu via scan QR.',
            service: '360 Videobooth'
        },
        {
            id: 5,
            name: 'Kevin Pratama',
            avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&auto=format&fit=crop&q=80',
            date: '2 weeks ago',
            rating: 5,
            comment: 'Paket bundling Photobooth + Undangan Digital sangat hemat dan praktis. Desain custom-nya persis seperti yang kami impikan. Thank you Visidea Studio!',
            service: 'Bundling Package'
        },
        {
            id: 6,
            name: 'Siti Rahmawati',
            avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&auto=format&fit=crop&q=80',
            date: '2 weeks ago',
            rating: 5,
            comment: 'Sangat terbantu dengan fitur amplop cashless QRIS dan RSVP otomatis di undangan digital. Laporannya real-time dan mudah dipantau kapan saja.',
            service: 'Digital Invitation'
        },
        {
            id: 7,
            name: 'Budi & Laras',
            avatar: 'https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?w=150&auto=format&fit=crop&q=80',
            date: '3 weeks ago',
            rating: 5,
            comment: 'Kerjasama dengan Event Organizer Visidea sangat luar biasa sigap dari awal technical meeting sampai hari-H selesai. Sukses terus untuk Visidea!',
            service: 'Event Organizer'
        },
        {
            id: 8,
            name: 'Amanda Vania',
            avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&auto=format&fit=crop&q=80',
            date: '1 month ago',
            rating: 5,
            comment: 'Hasil foto Vintage Photobooth-nya aesthetic banget, warnanya warm dan kualitas cetak fotonya sangat premium. Tamu undangan banyak yang suka!',
            service: 'Photobooth'
        }
    ];

    currentReviewSlideIndex: number = 0;
    isReviewDragging: boolean = false;
    reviewTouchStartX: number = 0;

    get reviewCardsPerView(): number {
        if (typeof window === 'undefined') return 3;
        if (this.screenWidth < 640) return 1;
        if (this.screenWidth < 1024) return 2;
        return 3;
    }

    get maxReviewSlideIndex(): number {
        return Math.max(0, this.customerReviews.length - this.reviewCardsPerView);
    }

    get reviewProgressPercentage(): number {
        if (this.maxReviewSlideIndex === 0) return 100;
        return Math.min(100, Math.max(15, ((this.currentReviewSlideIndex + 1) / (this.maxReviewSlideIndex + 1)) * 100));
    }

    nextReviewSlide(): void {
        if (this.currentReviewSlideIndex < this.maxReviewSlideIndex) {
            this.currentReviewSlideIndex++;
        } else {
            this.currentReviewSlideIndex = 0;
        }
    }

    prevReviewSlide(): void {
        if (this.currentReviewSlideIndex > 0) {
            this.currentReviewSlideIndex--;
        } else {
            this.currentReviewSlideIndex = this.maxReviewSlideIndex;
        }
    }

    onReviewTouchStart(e: TouchEvent): void {
        if (e.touches && e.touches.length > 0) {
            this.reviewTouchStartX = e.touches[0].clientX;
            this.isReviewDragging = true;
        }
    }

    onReviewTouchMove(e: TouchEvent): void {
        if (!this.isReviewDragging || !e.touches || e.touches.length === 0) return;
        const currentX = e.touches[0].clientX;
        const deltaX = currentX - this.reviewTouchStartX;
        const threshold = 40;
        if (deltaX < -threshold) {
            this.nextReviewSlide();
            this.reviewTouchStartX = currentX;
            this.isReviewDragging = false;
        } else if (deltaX > threshold) {
            this.prevReviewSlide();
            this.reviewTouchStartX = currentX;
            this.isReviewDragging = false;
        }
    }

    onReviewTouchEnd(): void {
        this.isReviewDragging = false;
    }

    // Modal All Reviews & Filters
    isAllReviewsModalOpen: boolean = false;
    reviewSearchQuery: string = '';
    selectedReviewFilter: string = 'all';

    openAllReviewsModal(): void {
        this.isAllReviewsModalOpen = true;
    }

    closeAllReviewsModal(): void {
        this.isAllReviewsModalOpen = false;
    }

    get filteredAllReviews(): Array<{
        id: number;
        name: string;
        avatar: string;
        date: string;
        rating: number;
        comment: string;
        service: string;
    }> {
        return this.customerReviews.filter(r => {
            const matchSearch = !this.reviewSearchQuery ||
                r.name.toLowerCase().includes(this.reviewSearchQuery.toLowerCase()) ||
                r.comment.toLowerCase().includes(this.reviewSearchQuery.toLowerCase()) ||
                (r.service && r.service.toLowerCase().includes(this.reviewSearchQuery.toLowerCase()));

            if (!matchSearch) return false;

            if (this.selectedReviewFilter === 'all') return true;
            if (this.selectedReviewFilter === '5') return r.rating === 5;
            if (this.selectedReviewFilter === '4') return r.rating === 4;
            if (this.selectedReviewFilter === 'photobooth') return r.service?.toLowerCase().includes('photobooth');
            if (this.selectedReviewFilter === 'invitation') return r.service?.toLowerCase().includes('invitation');
            if (this.selectedReviewFilter === 'guestbook') return r.service?.toLowerCase().includes('guest');
            return true;
        });
    }
}

